export let ZoomOption = /*#__PURE__*/function (ZoomOption) {
  ZoomOption["Z_WINDOW_SIZE"] = "WINDOW_SIZE";
  ZoomOption["Z_WINDOW_WIDTH"] = "WINDOW_WIDTH";
  ZoomOption[ZoomOption["Z_50"] = 0.5] = "Z_50";
  ZoomOption[ZoomOption["Z_75"] = 0.75] = "Z_75";
  ZoomOption[ZoomOption["Z_100"] = 1] = "Z_100";
  ZoomOption[ZoomOption["Z_125"] = 1.25] = "Z_125";
  ZoomOption[ZoomOption["Z_150"] = 1.5] = "Z_150";
  ZoomOption[ZoomOption["Z_200"] = 2] = "Z_200";
  ZoomOption[ZoomOption["Z_300"] = 3] = "Z_300";
  ZoomOption[ZoomOption["Z_400"] = 4] = "Z_400";
  return ZoomOption;
}({});